// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.installation-page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.installation-page__name {
  margin-top: 25px;
  font-size: 27px;
  font-weight: 700;
  color: rgb(7, 7, 7);
  text-transform: uppercase;
}
@media (max-width: 768px) {
  .installation-page__name {
    font-size: 27px;
  }
}
@media (max-width: 575px) {
  .installation-page__name {
    font-size: 24px;
  }
}
@media (max-width: 480px) {
  .installation-page__name {
    font-size: 18px;
  }
}
.installation-page__content {
  width: 100%;
}
.installation-page__title {
  font-size: 24px;
  font-weight: 700;
  color: rgb(7, 7, 7);
  text-transform: uppercase;
}
@media (max-width: 768px) {
  .installation-page__title {
    font-size: 27px;
  }
}
@media (max-width: 575px) {
  .installation-page__title {
    font-size: 24px;
  }
}
@media (max-width: 480px) {
  .installation-page__title {
    font-size: 18px;
  }
}
.installation-page__projects-content {
  display: flex;
  overflow-x: auto;
}
.installation-page__project {
  margin-right: 25px;
  font-size: 18px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 10px;
  list-style: none;
  transition: background-color 0.1s ease-in-out;
  white-space: nowrap;
}
@media (max-width: 575px) {
  .installation-page__project {
    font-size: 14px;
    padding: 10px 15px;
  }
}
@media (max-width: 500px) {
  .installation-page__project {
    padding: 5px 12px;
  }
}
@media (max-width: 450px) {
  .installation-page__project {
    padding: 5px 13px;
  }
}
@media (max-width: 450px) {
  .installation-page__project {
    padding: 5px 12px;
  }
}
@media (max-width: 400px) {
  .installation-page__project {
    font-size: 13px;
  }
}
.installation-page__project:hover {
  background-color: #23232d;
  color: white;
}
.installation-page__project:active {
  background-color: #1c1d25;
}
.installation-page__project.active {
  background-color: #1c1d25;
  color: white;
}
.installation-page__table {
  margin-top: 15px;
  width: 500px;
}
.installation-page__head {
  font-size: 16px;
  text-align: center;
}
@media (max-width: 460px) {
  .installation-page__head {
    font-size: 14px;
  }
}
.installation-page__body {
  font-size: 16px;
  text-align: center;
}
@media (max-width: 460px) {
  .installation-page__body {
    font-size: 14px;
  }
}
.installation-page__form {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.installation-page__logout {
  margin-top: 25px;
  margin-bottom: 50px;
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  color: #272833;
  cursor: pointer;
}
.installation-page__button-active {
  width: 100px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.installation-page__button-active.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .installation-page__button-active {
    width: auto;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.installation-page__button-noactive {
  width: 100px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.installation-page__button-noactive.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .installation-page__button-noactive {
    width: auto;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.installation-page__button-complaint {
  width: 100px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.installation-page__button-complaint.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .installation-page__button-complaint {
    width: auto;
    height: 20px;
    font-size: 10px;
  }
}

.projectinfo {
  margin-top: 15px;
}
.projectinfo__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.projectinfo__content-title {
  margin-top: 15px;
  font-size: 25px;
  color: rgb(7, 7, 7);
  font-weight: 600;
}
@media (max-width: 460px) {
  .projectinfo__content-title {
    font-size: 20px;
  }
}
.projectinfo__content-table {
  width: 50%;
}
@media (max-width: 460px) {
  .projectinfo__content-table {
    width: 100%;
  }
}
.projectinfo__content-money {
  margin-top: 25px;
}
.projectinfo__content-money__general {
  font-size: 18px;
  font-weight: 500;
  color: #272833;
}
.projectinfo__content-money__daily {
  margin-top: 3px;
  font-size: 18px;
  font-weight: 500;
  color: #272833;
}
.projectinfo .projectinfo__note {
  margin-bottom: 25px;
}
.projectinfo .projectinfo__note-title {
  padding-left: 20px;
  font-size: 22px;
  font-weight: 500;
  color: rgb(7, 7, 7);
}
@media (max-width: 768px) {
  .projectinfo .projectinfo__note-title {
    font-size: 18px;
  }
}
.projectinfo .projectinfo__note-content {
  margin: 25px 0px 15px 0px;
  padding: 20px;
  width: 100%;
  min-height: 200px;
  border-radius: 10px;
  border: 2px solid #9da1aa;
}
.projectinfo .projectinfo__note-field {
  font-size: 19px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  font-family: "Open Sans", sans-serif;
  white-space: pre-wrap; /* сохраняет абзацы и переносит текст по словам */
  word-break: break-word;
}
@media (max-width: 1024px) {
  .projectinfo .projectinfo__note-field {
    white-space: pre-wrap;
  }
}
@media (max-width: 768px) {
  .projectinfo .projectinfo__note-field {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .projectinfo .projectinfo__note-field {
    font-size: 14px;
  }
}
.projectinfo .projectinfo__note-show {
  font-size: 17px;
  font-weight: 400;
  color: #7d7f7d;
  text-align: center;
  cursor: pointer;
}
@media (max-width: 768px) {
  .projectinfo .projectinfo__note-show {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InstallationPage/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;AAAI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AAER;AAAQ;EAPJ;IAQQ,eAAA;EAGV;AACF;AAFQ;EAVJ;IAWQ,eAAA;EAKV;AACF;AAJQ;EAbJ;IAcQ,eAAA;EAOV;AACF;AAHI;EAEI,WAAA;AAIR;AACI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AACR;AAAQ;EALJ;IAMQ,eAAA;EAGV;AACF;AAFQ;EARJ;IASQ,eAAA;EAKV;AACF;AAJQ;EAXJ;IAYQ,eAAA;EAOV;AACF;AAHO;EACC,aAAA;EACA,gBAAA;AAKR;AAAI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EAEA,mBAAA;AACR;AACQ;EAbJ;IAcQ,eAAA;IACA,kBAAA;EAEV;AACF;AADQ;EAjBJ;IAkBQ,iBAAA;EAIV;AACF;AAHQ;EApBJ;IAqBQ,iBAAA;EAMV;AACF;AALQ;EAvBJ;IAwBQ,iBAAA;EAQV;AACF;AAPQ;EA1BJ;IA2BQ,eAAA;EAUV;AACF;AARQ;EACE,yBAAA;EACA,YAAA;AAUV;AAPQ;EACE,yBAAA;AASV;AALQ;EACI,yBAAA;EACA,YAAA;AAOZ;AAHI;EACI,gBAAA;EACA,YAAA;AAKR;AAFI;EACI,eAAA;EACA,kBAAA;AAIR;AAHQ;EAHJ;IAIQ,eAAA;EAMV;AACF;AAHI;EACI,eAAA;EACA,kBAAA;AAKR;AAJQ;EAHJ;IAIQ,eAAA;EAOV;AACF;AAJI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AAMR;AADI;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAGR;AAEQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAAZ;AACY;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAChB;AACY;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAEd;AACF;AAEQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAAZ;AACY;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAChB;AACY;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAEd;AACF;AACQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACZ;AAAY;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAEhB;AAAY;EAdJ;IAeQ,WAAA;IACA,YAAA;IACA,eAAA;EAGd;AACF;;AAIA;EACI,gBAAA;AADJ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AADR;AAIQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAFZ;AAGY;EALJ;IAMQ,eAAA;EAAd;AACF;AAGQ;EACI,UAAA;AADZ;AAEY;EAFJ;IAGQ,WAAA;EACd;AACF;AAEQ;EACI,gBAAA;AAAZ;AAEY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAhB;AAGY;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADhB;AAMI;EACI,mBAAA;AAJR;AAKQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAIY;EALJ;IAMQ,eAAA;EADd;AACF;AAIQ;EACI,yBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AAFZ;AAMQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA,EAAA,iDAAA;EACA,sBAAA;AAJZ;AAKY;EAPJ;IAQQ,qBAAA;EAFd;AACF;AAGY;EAVJ;IAWQ,eAAA;EAAd;AACF;AACY;EAbJ;IAcQ,eAAA;EAEd;AACF;AACQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AACZ;AAAY;EANJ;IAOQ,eAAA;EAGd;AACF","sourcesContent":[".installation-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &__name {\n        margin-top: 25px;\n        font-size: 27px;\n        font-weight: 700;\n        color: rgb(7, 7, 7);\n        text-transform: uppercase;\n\n        @media (max-width: 768px) {\n            font-size: 27px;\n        }\n        @media(max-width: 575px) {\n            font-size: 24px;\n        }\n        @media(max-width: 480px) {\n            font-size: 18px;\n        }\n    }\n    \n    \n    &__content {\n \n        width: 100%;\n        \n        \n    }\n\n    &__title {\n        font-size: 24px;\n        font-weight: 700;\n        color: rgb(7, 7, 7);\n        text-transform: uppercase;\n        @media (max-width: 768px) {\n            font-size: 27px;\n        }\n        @media(max-width: 575px) {\n            font-size: 24px;\n        }\n        @media(max-width: 480px) {\n            font-size: 18px;\n        }\n    }\n\n    &__projects {\n       &-content {\n        display: flex;\n        overflow-x: auto;\n       } \n        \n    }\n\n    &__project {\n        margin-right: 25px;\n        font-size: 18px;\n        font-weight: 400;\n        color: rgb(7,7,7);\n        cursor: pointer;\n        padding: 10px 20px;\n        border-radius: 10px;\n        list-style: none;\n        transition: background-color 0.1s ease-in-out;\n   \n        white-space: nowrap;\n        \n        @media(max-width: 575px) {\n            font-size: 14px;\n            padding: 10px 15px;\n        }\n        @media (max-width: 500px) {\n            padding: 5px 12px;\n        }\n        @media (max-width: 450px) {\n            padding: 5px 13px;\n        }\n        @media (max-width: 450px) {\n            padding: 5px 12px;\n        }\n        @media (max-width: 400px) {\n            font-size: 13px;\n        }\n  \n        &:hover {\n          background-color: darken(#272833, 2%);\n          color: #ffff;\n        }\n  \n        &:active {\n          background-color: darken(#272833, 5%);\n         \n        }\n  \n        &.active {\n            background-color: darken(#272833, 5%);\n            color: #ffff;\n          }\n    }\n\n    &__table {\n        margin-top: 15px;\n        width: 500px;\n    }\n\n    &__head {\n        font-size: 16px;\n        text-align: center;\n        @media(max-width: 460px) {\n            font-size: 14px;\n        }\n    }\n\n    &__body {\n        font-size: 16px;\n        text-align: center;\n        @media(max-width: 460px) {\n            font-size: 14px;\n        }\n    }\n\n    &__form {\n        margin-top: 10px;\n        display: flex;\n        justify-content: center;\n    }\n\n    \n\n    &__logout {\n        margin-top: 25px;\n        margin-bottom: 50px;\n        display: flex;\n        justify-content: center;\n        font-size: 18px;\n        font-weight: 500;\n        color:#272833;\n        cursor: pointer;\n    }\n\n\n    &__button {\n        &-active {\n            width: 100px;\n            height: 30px;\n            border: 1px solid #212529;\n            background-color: #212529;\n            color: #ffffff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            margin-right: 10px;\n            &.active {\n                background-color: #212529; /* Черный фон для активной кнопки */\n                color: #ffffff; /* Белый текст для активной кнопки */\n            }\n            @media(max-width: 460px) {\n                width: auto;\n                height: 20px;\n                font-size: 10px;\n                margin-right: 5px;\n                \n            }\n        }\n\n        &-noactive {\n            width: 100px;\n            height: 30px;\n            border: 1px solid #212529;\n            background-color: #212529;\n            color: #ffffff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            margin-right: 10px;\n            &.active {\n                background-color: #212529; /* Черный фон для активной кнопки */\n                color: #ffffff; /* Белый текст для активной кнопки */\n            }\n            @media(max-width: 460px) {\n                width: auto;\n                height: 20px;\n                font-size: 10px;\n                margin-right: 5px;\n            }\n        }\n\n        &-complaint {\n            width: 100px;\n            height: 30px;\n            border: 1px solid #212529;\n            background-color: #212529;\n            color: #ffffff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            &.active {\n                background-color: #212529; /* Черный фон для активной кнопки */\n                color: #ffffff; /* Белый текст для активной кнопки */\n            }\n            @media(max-width: 460px) {\n                width: auto;\n                height: 20px;\n                font-size: 10px;\n            }\n        }\n    }\n}\n\n//projectinfo\n\n.projectinfo {\n    margin-top: 15px;\n\n    &__content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n      \n\n        &-title {\n            margin-top: 15px;\n            font-size: 25px;\n            color: rgb(7, 7, 7);\n            font-weight: 600;\n            @media(max-width: 460px) {\n                font-size: 20px;\n            }\n        }\n\n        &-table {\n            width: 50%;\n            @media(max-width: 460px) {\n                width: 100%;\n            }\n        }\n\n        &-money {\n            margin-top: 25px;\n    \n            &__general {\n                font-size: 18px;\n                font-weight: 500;\n                color: #272833;\n            }\n    \n            &__daily {\n                margin-top: 3px;\n                font-size: 18px;\n                font-weight: 500;\n                color: #272833;\n            }\n        }\n    }\n\n    .projectinfo__note {\n        margin-bottom: 25px;\n        &-title {\n            padding-left: 20px;\n            font-size: 22px;\n            font-weight: 500;\n            color: rgb(7,7,7);\n            @media(max-width: 768px) {\n                font-size: 18px;\n            }\n        }\n\n        &-content {\n            margin: 25px 0px 15px 0px;\n            padding: 20px;\n            width: 100%;\n            min-height: 200px;\n            border-radius: 10px;\n            border: 2px solid #9da1aa;\n            \n        }\n\n        &-field {\n            font-size: 19px;\n            font-weight: 400;\n            color: rgb(7,7,7);\n            font-family: \"Open Sans\", sans-serif;\n            white-space: pre-wrap; /* сохраняет абзацы и переносит текст по словам */\n            word-break: break-word;\n            @media(max-width: 1024px) {\n                white-space: pre-wrap;\n            }\n            @media(max-width: 768px) {\n                font-size: 16px;\n            }\n            @media(max-width: 480px) {\n                font-size: 14px;\n            }\n        }\n\n        &-show {\n            font-size: 17px;\n            font-weight: 400;\n            color: #7d7f7d;\n            text-align: center;\n            cursor: pointer;\n            @media(max-width: 768px) {\n                font-size: 14px;\n            }\n        }\n    \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
